// Centralized site content & assets.
// NOTE: images below are placeholders — swap the URLs when the client's real
// photos are uploaded (keep the same keys/filenames).

export const COMPANY = {
  name: "Lisse Energies",
  baseline:
    "Chauffage · Plomberie · Climatisation · Pompe à chaleur · Poêle à granulés — Installation · Entretien · Dépannage",
  shortBaseline: "Installation · Entretien · Dépannage",
  address: {
    street: "1 A Route de Sion",
    zip: "54116",
    city: "Praye",
    department: "Meurthe-et-Moselle (54)",
    full: "1 A Route de Sion, 54116 Praye",
  },
  zone: "tout le Saintois et l'agglomération de Nancy",
  phone: "06 66 36 54 60",
  phoneLink: "tel:+33666365460",
  email: "lisseenergies@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=100090427614032",
  instagram: "https://www.instagram.com/lisse.energies/",
  googleReviews:
    "https://search.google.com/local/reviews?placeid=ChIJa6hDwehdk0cRM_LWtz8UYjA",
  rating: "5/5",
  reviewsCount: 45,
  rgePlaceholder: "[Numéro RGE Qualit'EnR à compléter]",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/aeeoa0i6_Logo%20Lisse%20energie.png",
  heroHeatpump:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/eud9hg0r_Pompes%20%C3%A0%20chaleur.png",
  pompeAChaleurMitsubishi:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/eud9hg0r_Pompes%20%C3%A0%20chaleur.png",
  poeleFoyerBois1: "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/gl1rl3tu_Po%C3%AAles%20%26%20foyers%20bois.png",
  poeleFoyerBois2: "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/z1rr9fat_Po%C3%AAles%20%26%20foyers%20bois2.png",
  climatisationMitsubishi:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/an346bq9_Clim.png",
  radiateurElectrique:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/89zf4ijk_Chauffage%20%C3%A9lectrique.png",
  solaireThermiqueViessmann:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/a3d055gr_Solaire%20thermique.png",
  plomberieSanitaireWc:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/k8l2jh9b_Plomberie%20et%20sanitaire.png",
  chaudiereBoisGranulesPerge:
    "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/le2irr06_Chaudi%C3%A8res%20boisgranul%C3%A9s.png",
  technicien: "https://customer-assets.emergentagent.com/job_artisan-rge-staging/artifacts/sngvzlzf_fond.png",
};

// Home services preview cards
export const SERVICES = [
  {
    id: "chauffage",
    icon: "Thermometer",
    title: "Chauffage",
    desc: "Installation et rénovation de systèmes de chauffage performants et économes.",
    rge: false,
  },
  {
    id: "pompe-a-chaleur",
    icon: "Fan",
    title: "Pompe à chaleur",
    desc: "Air/air et air/eau — le confort toute l'année, avec un rendement optimal.",
    rge: true,
  },
  {
    id: "poele-chaudiere-bois",
    icon: "Fire",
    title: "Poêle & chaudière bois/granulés",
    desc: "Poêles, inserts et chaudières bois/granulés pour une chaleur naturelle.",
    rge: true,
  },
  {
    id: "climatisation",
    icon: "Snowflake",
    title: "Climatisation",
    desc: "Climatisation réversible : fraîcheur en été, chauffage d'appoint en hiver.",
    rge: false,
  },
  {
    id: "plomberie",
    icon: "Drop",
    title: "Plomberie / sanitaire",
    desc: "Rénovation sanitaire, réseaux d'eau et installations soignées.",
    rge: false,
  },
  {
    id: "entretien",
    icon: "Wrench",
    title: "Entretien & dépannage",
    desc: "Entretien régulier et interventions de dépannage réactives.",
    rge: false,
  },
];

// Full prestations page (order matters)
export const PRESTATIONS = [
  {
    id: "pompe-a-chaleur",
    icon: "Fan",
    title: "Pompe à chaleur",
    subtitle: "Air/air & air/eau",
    text: "La pompe à chaleur puise l'énergie de l'air extérieur pour chauffer votre logement et produire de l'eau chaude, avec un rendement remarquable. Une solution durable, économique et confortable, adaptée à la rénovation comme au neuf.",
    image: IMAGES.pompeAChaleurMitsubishi,
    alt: "Pompe à chaleur installée par Lisse Energies dans le Saintois",
    rge: true,
  },
  {
    id: "poele-insert-bois",
    icon: "Fire",
    title: "Poêle & insert à bois",
    subtitle: "Chaleur naturelle",
    text: "Poêles et inserts à bois pour une chaleur enveloppante et une ambiance chaleureuse. Nous étudions l'implantation, le conduit et l'habillage pour un rendu à la fois performant et esthétique.",
    image: IMAGES.poeleFoyerBois1,
    alt: "Installation de poêle et insert à bois par Lisse Energies",
    rge: true,
  },
  {
    id: "chaudiere-bois-granules",
    icon: "Flame",
    title: "Chaudière bois & granulés",
    subtitle: "Énergie renouvelable",
    text: "La chaudière bois/granulés chauffe l'ensemble de votre maison avec un combustible renouvelable et local. Une alternative économique et écologique aux énergies fossiles.",
    image: IMAGES.chaudiereBoisGranulesPerge,
    alt: "Chaudière bois et granulés installée par Lisse Energies",
    rge: true,
  },
  {
    id: "climatisation",
    icon: "Snowflake",
    title: "Climatisation réversible",
    subtitle: "Confort toute l'année",
    text: "La climatisation réversible rafraîchit en été et apporte un chauffage d'appoint efficace en hiver. Des unités discrètes et silencieuses, dimensionnées selon vos pièces.",
    image: IMAGES.climatisationMitsubishi,
    alt: "Climatisation réversible — unité intérieure",
    rge: false,
  },
  {
    id: "chauffage-electrique",
    icon: "Thermometer",
    title: "Chauffage électrique",
    subtitle: "Radiateurs performants",
    text: "Radiateurs électriques nouvelle génération, précis et économes, pour un confort maîtrisé pièce par pièce.",
    image: IMAGES.radiateurElectrique,
    alt: "Radiateur électrique design installé par Lisse Energies",
    rge: false,
  },
  {
    id: "solaire-thermique",
    icon: "Sun",
    title: "Solaire thermique",
    subtitle: "L'énergie du soleil",
    text: "Le solaire thermique utilise l'énergie du soleil pour produire votre eau chaude sanitaire et contribuer au chauffage. Une source d'énergie gratuite et inépuisable.",
    image: IMAGES.solaireThermiqueViessmann,
    alt: "Installation de panneaux solaires thermiques",
    rge: false,
  },
  {
    id: "plomberie-sanitaire",
    icon: "Drop",
    title: "Plomberie & sanitaire",
    subtitle: "Rénovation & réseaux",
    text: "Rénovation de salle de bain, WC suspendus, réseaux d'eau et évacuations : une plomberie soignée, propre et durable.",
    image: IMAGES.plomberieSanitaireWc,
    alt: "Rénovation sanitaire — WC suspendu par Lisse Energies",
    rge: false,
  },
];

export const REALISATIONS = [
  { src: IMAGES.poeleFoyerBois1, caption: "Installation de poêle à bois", category: "poele-chaudiere-bois" },
  { src: IMAGES.poeleFoyerBois2, caption: "Foyer bois — habillage pierre", category: "poele-chaudiere-bois" },
  { src: IMAGES.pompeAChaleurMitsubishi, caption: "Pose d'une pompe à chaleur", category: "pompe-a-chaleur" },
  { src: IMAGES.climatisationMitsubishi, caption: "Climatisation réversible — unité intérieure", category: "climatisation" },
  { src: IMAGES.radiateurElectrique, caption: "Radiateur électrique design", category: "chauffage-electrique" },
  { src: IMAGES.solaireThermiqueViessmann, caption: "Installation de panneaux solaires thermiques", category: "solaire" },
  { src: IMAGES.plomberieSanitaireWc, caption: "Rénovation sanitaire — WC suspendu", category: "plomberie" },
  { src: IMAGES.chaudiereBoisGranulesPerge, caption: "Chaufferie bois/granulés", category: "poele-chaudiere-bois" },
];

export const GALLERY_CATEGORIES = [
  { value: "pompe-a-chaleur", label: "Pompe à chaleur" },
  { value: "poele-chaudiere-bois", label: "Poêle & chaudière bois" },
  { value: "climatisation", label: "Climatisation" },
  { value: "chauffage-electrique", label: "Chauffage électrique" },
  { value: "solaire", label: "Solaire thermique" },
  { value: "plomberie", label: "Plomberie" },
  { value: "entretien", label: "Entretien & dépannage" },
];

export const CATEGORY_LABELS = GALLERY_CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label;
  return acc;
}, {});

// ---- Galerie Réalisations (49 photos statiques dans /public/realisations) ----
export const REALISATION_CATEGORIES = [
  { value: "pompe-a-chaleur", label: "Pompe à chaleur" },
  { value: "chaudiere", label: "Chaudière & chaufferie" },
  { value: "poele", label: "Poêle & insert à bois" },
  { value: "climatisation", label: "Climatisation" },
  { value: "plomberie", label: "Plomberie & sanitaire" },
  { value: "chauffage", label: "Chauffage & radiateurs" },
  { value: "solaire", label: "Solaire thermique" },
];

const pad = (n) => String(n).padStart(2, "0");

function buildRealisationPhotos() {
  const list = [];
  const add = (name, category, caption) =>
    list.push({ src: `/realisations/${name}.jpg`, category, caption });

  // Pompe à chaleur (12)
  for (let i = 1; i <= 11; i++) add(`pac_${pad(i)}`, "pompe-a-chaleur", "Pompe à chaleur");
  add("ballon_thermodynamique_01", "pompe-a-chaleur", "Chauffe-eau thermodynamique");
  // Chaudière & chaufferie (12)
  for (let i = 1; i <= 12; i++) add(`chaudiere_${pad(i)}`, "chaudiere", "Chaudière & chaufferie");
  // Poêle & insert à bois (5)
  for (let i = 1; i <= 5; i++) add(`poele_${pad(i)}`, "poele", "Poêle & insert à bois");
  // Climatisation (6)
  for (let i = 1; i <= 6; i++) add(`clim_${pad(i)}`, "climatisation", "Climatisation réversible");
  // Plomberie & sanitaire (6)
  add("plomberie_01", "plomberie", "Plomberie & sanitaire");
  for (let i = 1; i <= 3; i++) add(`salle_de_bain_${pad(i)}`, "plomberie", "Rénovation de salle de bain");
  for (let i = 1; i <= 2; i++) add(`douche_${pad(i)}`, "plomberie", "Rénovation de douche");
  // Chauffage & radiateurs (6)
  add("elec_01", "chauffage", "Chauffage électrique");
  for (let i = 1; i <= 2; i++) add(`radiateur_eau_${pad(i)}`, "chauffage", "Radiateur à eau");
  for (let i = 1; i <= 3; i++) add(`plancher_chauffant_${pad(i)}`, "chauffage", "Plancher chauffant");
  // Solaire thermique (2)
  for (let i = 1; i <= 2; i++) add(`solaire_${pad(i)}`, "solaire", "Solaire thermique");

  return list;
}

export const REALISATION_PHOTOS = buildRealisationPhotos();

// 8 photos d'origine (uploads précédents) — remises dans la galerie, remappées sur les 7 catégories.
export const LEGACY_REALISATION_PHOTOS = [
  { src: IMAGES.pompeAChaleurMitsubishi, caption: "Pose d'une pompe à chaleur", category: "pompe-a-chaleur" },
  { src: IMAGES.chaudiereBoisGranulesPerge, caption: "Chaufferie bois/granulés", category: "chaudiere" },
  { src: IMAGES.poeleFoyerBois1, caption: "Installation de poêle à bois", category: "poele" },
  { src: IMAGES.poeleFoyerBois2, caption: "Foyer bois — habillage pierre", category: "poele" },
  { src: IMAGES.climatisationMitsubishi, caption: "Climatisation réversible — unité intérieure", category: "climatisation" },
  { src: IMAGES.radiateurElectrique, caption: "Radiateur électrique design", category: "chauffage" },
  { src: IMAGES.solaireThermiqueViessmann, caption: "Installation de panneaux solaires thermiques", category: "solaire" },
  { src: IMAGES.plomberieSanitaireWc, caption: "Rénovation sanitaire — WC suspendu", category: "plomberie" },
];

export const COMMUNES = [
  "Praye", "Vézelise", "Tantonville", "Ceintrey", "Voinémont", "Haroué",
  "Neuves-Maisons", "Ludres", "Nancy", "Vandœuvre-lès-Nancy",
];

export const PROJECT_TYPES = [
  { value: "pompe-a-chaleur", label: "Pompe à chaleur" },
  { value: "poele-chaudiere-bois", label: "Poêle / chaudière bois" },
  { value: "climatisation", label: "Climatisation" },
  { value: "plomberie", label: "Plomberie" },
  { value: "entretien-depannage", label: "Entretien / dépannage" },
  { value: "autre", label: "Autre" },
];

export const RGE_SERVICES =
  "pompe à chaleur, chaudière bois/granulés et chauffe-eau thermodynamique";
